import React from 'react';
import { Chip } from '@mui/material';

const colorMap = {
  queued: { bg: '#eef2ff', fg: '#3730a3' },
  sent: { bg: '#ecfdf5', fg: '#065f46' },
  failed: { bg: '#fef2f2', fg: '#991b1b' },
  delivered: { bg: '#f0fdf4', fg: '#166534' }
};

const EmailStatusChip = ({ status }) => {
  const s = String(status || '').toLowerCase();
  const c = colorMap[s] || { bg: '#f3f4f6', fg: '#374151' };
  return (
    <Chip
      size="small"
      label={status}
      sx={{
        backgroundColor: c.bg,
        color: c.fg,
        fontWeight: 600,
        textTransform: 'capitalize'
      }}
    />
  );
};

export default EmailStatusChip;


